<template>
  <div class="k-ingredient-card" v-if="!item.recipes || getFilteredRecipes(item.recipes).length > 0">
    <img :src="item.cover_url" alt="" @click.self="checkBoughted">
    <div class="d-flex justify-content-between w-100" @click.self="checkBoughted">
      <div class="k-ingredient-card__header">
        <p class="k-ingredient-card__header-main" v-if="true">{{ item.title }}</p>
        <adaptive-propper v-else>
          <template #element>
            <p class="k-ingredient-card__header-main title-hover">Картофель</p>
          </template>
          <template #content>
            <div class="k-subingredients">
              <div class="k-subingredient d-flex justify-content-between mb-2" v-for="i in 7" :key="i">
                <span>
                  <span>
                    <svg class="mr-3" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.6157 19.9723C3.29371 19.9723 1.1645 17.3028 1.0056 11.7732C0.846706 6.72028 4.08819 1.54025 8.12417 1" stroke="#F68C1E" stroke-miterlimit="10"/>
                      <path d="M15.3069 12.6948C15.4658 7.64188 12.2243 1.54025 8.18835 1" stroke="#F68C1E" stroke-miterlimit="10" stroke-linecap="round"/>
                      <path d="M7.61403 19.9701C7.58226 15.6481 10.4106 12.9151 15.9402 12.7244C20.9931 12.5337 26.1732 15.7434 26.7452 19.7794" stroke="#F68C1E" stroke-miterlimit="10"/>
                      <path d="M7.61377 19.8461C7.64555 24.1681 10.4739 26.8693 16.0035 26.9965C21.0564 27.1236 26.2047 23.8503 26.7449 19.8143" stroke="#F68C1E" stroke-miterlimit="10" stroke-linecap="round"/>
                    </svg>
                  </span>
                  Яйца
                </span>
                <span>
                  30 г
                </span>
              </div>
            </div>
          </template>
          <template #button>
            <div class="k-article__button mx-auto">
              Приготовлю сам
            </div>
          </template>
        </adaptive-propper>
        <p class="k-ingredient-card__header-additional">{{ item.amount_title }} </p>
      </div>
      <div class="d-flex">
        <!--
        <adaptive-propper class="mr-2" v-if="currentTab === 'ingredients'">
          <template #element="{ active }">
            <div class="k-ingredient-card__action-icon" :class="{ active: active }">
              <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.3661 11.0197H21.4792C20.698 6.86162 17.4158 3.64928 13.3476 2.8981C13.4745 2.63362 13.5457 2.33751 13.5457 2.0251C13.5457 0.90846 12.6372 0 11.5206 0C10.4039 0 9.49547 0.90846 9.49547 2.0251C9.49547 2.33755 9.56671 2.63362 9.69357 2.8981C5.62537 3.64923 2.34318 6.86158 1.56198 11.0197H0.675033C0.302235 11.0197 0 11.322 0 11.6948C0 14.0686 1.92461 16 4.2902 16H18.7509C21.1165 16 23.0411 14.0687 23.0411 11.6948C23.0411 11.322 22.7389 11.0197 22.3661 11.0197ZM11.5206 1.35007C11.8928 1.35007 12.1956 1.65289 12.1956 2.0251C12.1956 2.39731 11.8928 2.70013 11.5206 2.70013C11.1484 2.70013 10.8455 2.39731 10.8455 2.0251C10.8455 1.65289 11.1484 1.35007 11.5206 1.35007ZM11.5206 4.08094C15.6673 4.08094 19.2299 7.01413 20.1024 11.0197H2.93869C3.81128 7.01413 7.37379 4.08094 11.5206 4.08094ZM18.7509 14.6499H4.2902C2.89994 14.6499 1.732 13.6751 1.42747 12.3698H2.13788H20.9033H21.6137C21.3091 13.6751 20.1412 14.6499 18.7509 14.6499Z" fill="#A0A0A0"/>
              </svg>
            </div>
          </template>
          <template #content>
            <div class="k-ingredient-dish mb-2" v-for="i in 3" :key="i">
              <img src="img/dish.png" alt="dish" class="mr-2 rounded-circle">
              <div class="k-ingredient-card__header k-ingredient-dish__header">
                <p class="k-ingredient-card__header-main">Длинное название супа</p>
                <p class="k-ingredient-card__header-additional">300 г</p>
              </div>
            </div>
          </template>
        </adaptive-propper>
        -->
        <div class="k-ingredient-card__select" :class="{ active: item.is_bought === 't' }" @click.self="checkBoughted">
          <svg width="16" height="12" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 3.52308L3.21429 5L6.5 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <adaptive-propper height="300" width="470" v-if="currentTab === 'ingredients'">
          <template #element="{ active }">
            <div class="k-ingredient-card__action-icon" :class="{ active: active }">
              <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2" cy="2" r="2" fill="#A0A0A0"/>
                <circle cx="2" cy="8" r="2" fill="#A0A0A0"/>
                <circle cx="2" cy="14" r="2" fill="#A0A0A0"/>
              </svg>
            </div>
          </template>
          <template #top-button v-if="false">
            <div class="d-flex justify-content-center w-100 mb-3">
              <span class="circle-button circle-button--red mr-3" @click="downIngredientWeight()">
                <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="16" y="0.109375" width="1.77778" height="16" rx="0.888889" transform="rotate(90 16 0.109375)" fill="white"/>
                </svg>
              </span>
              <span v-if="!needRerender">{{ item.amount_title }}</span>
              <span class="circle-button circle-button--green ml-3" @click="upIngredientWeight()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="7.11108" width="1.77778" height="16" rx="0.888889" fill="white"/>
                  <rect x="16" y="7.10938" width="1.77778" height="16" rx="0.888889" transform="rotate(90 16 7.10938)" fill="white"/>
                </svg>
              </span>
            </div>
          </template>
          <template #content="{ mobile }">
            <div class="d-flex flex-column h-100" :class="{ 'flex-column-reverse pb-5': mobile }">
              <div v-for="({ recipe, meal, set_meal }, index) in getFilteredRecipes(item.recipes)" :key="index">
                <div class="k-ingredient-dish my-1">
                  <div class="d-flex align-items-center w-100">
                    <img :src="recipe.cover_url" alt="dish" >
                    <div class="k-ingredient-card__header k-ingredient-dish__header w-100">
                      <p class="k-ingredient-card__header-main mb-1"  style="pointer-events: all" @click="gotoRecipe(recipe, meal || set_meal, meal ? 'meal' : 'set_meal')">{{ recipe.title }}</p>
                      <p class="k-ingredient-card__header-additional d-flex justify-content-between align-items-center flex-wrap" v-if="set_meal || meal">
                        <span class="k-badge badge k-badge-orange-dark">{{ getMealType(meal ? meal.meal_type : set_meal.meal_type) }}</span>
                        <span class="k-badge badge k-badge-orange-dark">{{recipe.number_of_servings + (recipe.guest_count || 0)}} {{ declOfNum(recipe.number_of_servings + (recipe.guest_count || 0), ['порция','порции','порций']) }}</span>
                        <span class="k-ingridient-card__text-date">{{ normalizeDate(meal ? meal.date : set_meal.date) }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="k-ingredient--wiehgt-text d-flex ml-2 justify-content-center align-items-center text-nowrap h-100">
                    {{ recipe.info.amount_title }}
                  </div>
                  <div class="mx-2 cursor-pointer k-ingredients-eye" v-if="!needRerender">
                    <div
                      class="k-ingredient-card__select mx-0" :class="{ active: recipe.is_hidden === 't' }" @click="toggleHidden(recipe, meal || set_meal, recipe.is_hidden === 't' ? 'f' : 't')">
                      <svg width="16" height="12" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.5 3.52308L3.21429 5L6.5 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <!--
                    <img :src="require('../assets/eye.svg')" alt="eye" v-if="recipe.is_hidden !== 't'" @click="toggleHidden(recipe, meal || set_meal, 't')">
                    <img :src="require('../assets/eye-cross.svg')" alt="eye" v-else @click="toggleHidden(recipe, meal || set_meal, 'f')">
                    -->
                  </div>
                </div>
                <div class="k-ingredient-card__divider mt-2"></div>
              </div>
            </div>
          </template>
        </adaptive-propper>
        <adaptive-propper height="80" v-else-if="false" noscrollbar>
          <template #element="{ active }">
            <div class="k-ingredient-card__action-icon" :class="{ active: active }">
              <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2" cy="2" r="2" fill="#A0A0A0"/>
                <circle cx="2" cy="8" r="2" fill="#A0A0A0"/>
                <circle cx="2" cy="14" r="2" fill="#A0A0A0"/>
              </svg>
            </div>
          </template>
          <template #content>
             <div class="d-flex justify-content-center w-100 mb-3">
              <span class="circle-button circle-button--red mr-3" @click="downIngredientWeight()">
                <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="16" y="0.109375" width="1.77778" height="16" rx="0.888889" transform="rotate(90 16 0.109375)" fill="white"/>
                </svg>
              </span>
              <span v-if="!needRerender">{{ item.custom_weight || item.weight }} г</span>
              <span class="circle-button circle-button--green ml-3" @click="upIngredientWeight()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="7.11108" width="1.77778" height="16" rx="0.888889" fill="white"/>
                  <rect x="16" y="7.10938" width="1.77778" height="16" rx="0.888889" transform="rotate(90 16 7.10938)" fill="white"/>
                </svg>
              </span>
            </div>
          </template>
        </adaptive-propper>
      </div>
    </div>
  </div>
</template>

<script>
import { setIngredientData, setMealData } from '../api/PurchasesApi';
import AdaptivePropper from '../components/TheAdaptivePropper';
import { declOfNum } from '../utils/helper';
import dateFormat from '../utils/dateformat';
import { mapGetters } from 'vuex';

export default {
  props: {
    currentTab: {
      type: String,
      default: 'ingredients',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    date: {
      default: '',
    },
    start_date: {
      default: '',
    },
    end_date: {
      default: '',
    },
    recipe: {
      default: null
    },
  },
  components: {
    AdaptivePropper,
  },
  data: () => ({
    isActive: false,
    declOfNum,
    needRerender: false,
  }),
  mounted() {
    this.$set(this.item, 'default_weight', this.item.weight)
  },
  computed: {
    ...mapGetters([
      "getMealReferences",
    ]),
  },
  methods: {
    gotoRecipe(/* recipe, meal, type */) {
      return;
      /*
      console.log('reee', recipe, meal, type)
      recipe[type] = meal;
      this.$router.push({ name: 'ReceipesDetail', query: { date: recipe.meal.date, meal_id: recipe.meal && recipe.meal.id, set_meal_id: recipe.set_meal && recipe.set_meal.id, type: recipe.set_meal && 'special' }, params: { id: recipe.id } })
      */
    },
    getMealType(meal_type) {
      return this.getMealReferences[meal_type];
    },
    getFilteredRecipes(recipes) {
      return recipes.filter(el => el.recipe.will_not_cook !== 't')
    },
    async toggleHidden(recipe, meal, value, force = true) {

      await setMealData({
        meal_id: !meal.recipe_set_id && meal.id,
        set_meal_id: meal.recipe_set_id && meal.id,
        ingredient_id: this.item.id,
        recipe_id: recipe.id,
        is_hidden: value,
        start_date: this.start_date || this.date,
        end_date: this.end_date || (this.start_date || this.date)
      })

      if (force) {
        this.$set(recipe, 'is_hidden', value);

        this.$forceUpdate();
        this.needRerender = true;
        await this.$nextTick();
        this.needRerender = false;

        this.$emit('reload');
      }
    },
    async upIngredientWeight() {
      const weight_property = this.item.custom_weight ? 'custom_weight' : 'weight';

      const new_weight = parseFloat((this.item[weight_property] + this.checkWeightMaxDiffChange()).toFixed(2));
      await this.changeWeight(new_weight);

      this.$set(this.item, weight_property, new_weight);
      this.$forceUpdate();
      this.needRerender = true;
      await this.$nextTick();
      this.needRerender = false;
    },
    async downIngredientWeight() {
      const weight_property = this.item.custom_weight ? 'custom_weight' : 'weight';

      const new_weight = parseFloat((this.item[weight_property] - this.checkWeightMaxDiffChange()).toFixed(2));
      if (new_weight > 0) {
        await this.changeWeight(new_weight);

        this.$set(this.item, weight_property, new_weight);
        this.$forceUpdate();
        this.needRerender = true;
        await this.$nextTick();
        this.needRerender = false;
      }
    },
    checkWeightMaxDiffChange() {
      const weights = [1, 5, 10, 25, 50, 100];
      const index = weights.findIndex(el => ~~(this.item.default_weight / el) < 1) || 50
      return weights[index - 1] || 1
    },
    normalizeDate(date) {
      return dateFormat(date, 'dd mmmm yyyy')
    },
    async changeWeight(weight) {
      await setIngredientData({
        ingredient_id: this.item.id,
        start_date: this.start_date || this.date,
        end_date: this.end_date || (this.start_date || this.date),
        weight,
      })
    },
    async checkBoughted() {
      this.item.is_bought = this.item.is_bought === 't' ? 'f' : 't';
      this.$forceUpdate();

      if (this.recipe) {
        await this.toggleHidden(this.recipe, this.recipe.meal ? this.recipe.meal : this.recipe.set_meal, this.item.is_bought, false);
      }

      await setIngredientData({
        ingredient_id: this.item.id,
        is_bought: this.item.is_bought,
        start_date: this.start_date || this.date,
        end_date: this.end_date || (this.start_date || this.date)
      })


      setTimeout(() => {
        this.$emit('bought', this.item.is_bought)
      }, 700);
    },
  }
}
</script>

<style lang="scss">
.k-ingredient-card {
  .popover__content-mobile {
    margin: 0 -15px;
  }
}
</style>
<style lang="scss" scoped>
.k-ingredient-card {
  width: 380px;
  min-height: 80px;
  margin-right: 24px;
  margin-bottom: 4px;
  background: #FFFFFF;
  border: 1px solid #EEEEF0;
  box-sizing: border-box;
  display: flex;
  box-shadow: 1px 2px 20px rgba(0, 0, 0, 0.05);
  align-items: center;
  word-break: break-word;

  padding: 12px 18px;

  img {
    max-width: 100px;
    clip-path: circle();
    -webkit-clip-path: circle();
  }
}

.k-ingredient-card__select {
  border: 1px solid #F7981E;
  box-sizing: border-box;
  min-width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 4px;
  margin-left: 4px;

  svg {
    display: none;
  }
  &.active {
    background: #F7981E;
    svg {
      display: block;
    }
  }
}
.k-ingredients-eye {
  img {
    width: 20px;
    height: 20px;
  }
}
.k-ingredient-card__header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;

  p {
    margin: 0;
  }
}
.k-ingredient-card__header-main {
  font-size: 17px;
  color: #616161;
  line-height: 1;
}
.k-ingredient-card__header-additional {
  font-weight: 600;
  font-size: 12px;
  color: #000000;
}
.k-purchase__title-description {
  font-size: 16px;
  color: #616161;
  font-weight: 600;
}
.k-ingredient-card__action-icon {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.active {
    background: #F68C1E;
    border-radius: 50%;

    path,
    circle {
      fill: #fff !important;
    }
  }
}

.k-ingredient-dish {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.k-ingredient-dish__header {
  flex-grow: unset;
  text-align: left;
}

.circle-button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &--red {
    background: #D51E3A;
  }
  &--green {
    background: #9DC43B;
  }
}

.icon-button {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-hover:hover {
  color: orange;
  text-decoration: underline;
  cursor: pointer;
}

.k-ingridient-card__text-date {
  font-size: 10px;
  color: #616161;
  opacity: 0.6;
  white-space: nowrap;
}

.k-ingredient-card__divider {
  width: 100%;
  height: 1px;
  background: #E1E1E1;
}
.k-ingredient--wiehgt-text {
  font-weight: 600;
  font-size: 12px;
  color: #616161;
  opacity: 0.6;
}
@media (max-width: 767.98px) {
  .k-ingredient-card img {
    max-width: 70px;
    max-height: 100%;
  }
  .k-ingredient-card {
    margin-right: 0;
    width: 100%;
  }
  .k-ingredient-card__select {
    min-width: 32px;
    height: 32px;
    margin-right: 15px;

    svg {
      width: 17px;
      height: 13px;
    }
  }
}
</style>
